(function () {
    'use strict';

    var impersonateService = function ($http) {

        this.getUrl = function (clientId, accountId, clientDetailsId) {
            return $http.post('api/impersonate/getclientredirecturl',
                {
                    clientDetailsId: clientDetailsId,
                    accountId: accountId,
                    clientId: clientId
                })
                .then(function(response) {
                        var url = response.data.url;

                        return url;
                    },
                    function() {
                        throw ('Error getting URL');
                    });
        };


    }

    angular.module('app')
        .service('impersonateService', ['$http', impersonateService]);
})();